import { render } from "./basicExamples.vue?vue&type=template&id=287f4c52"
import script from "./basicExamples.vue?vue&type=script&lang=js"
export * from "./basicExamples.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__